

















































































































































import { Vue, Component, Mixins } from "vue-property-decorator";
import MyForm from "@/mixins/form";

@Component
export default class extends Mixins(MyForm) {
  data: any[] = [];

  handleSubmit() {
    this.form.validateFields((err: any, values: any) => {
      if (!err) {
        this.showTsConfirm({
          title: "确认信息",
          content: "确定要提交吗？",
          onOk: async () => {
            this.confirmLoading = true;
            const res = await this.$store.dispatch("setting/edit", {
              id: this.editId,
              ...values,
            });
            if (res && res.Message === "success") {
              this.$message.success(res.Message);

              this.handleCancel();
            } else {
              this.$message.error(res.Message);
            }
            this.confirmLoading = false;
          },
        });
      }
    });
  }

  async mounted() {
    this.spinLoading = true;
    const res1 = await this.$store.dispatch("setting/detail", {
      id: this.editId,
    });
    if (res1 && res1.Message === "success") {
      this.formData = res1.Data;
      //   this.formData.setting_rule = JSON.parse(res1.Data.setting_rule)
      const rules = JSON.parse(res1.Data.setting_rule);
      const newrules = [];

      for (const k in rules) {
        newrules.push({ name: k, value: rules[k] });
      }
      this.formData.setting_rule = newrules;
      //   console.log(this.formData)
    }
    this.spinLoading = false;
  }

  addRule(idx: number) {
    this.formData.setting_rule.push({
      name: "",
      value: "",
    });
  }

  removeRule(idx: number) {
    this.formData.setting_rule.splice(idx, 1);
  }
}
